import '../vendors/theia-sticky-sidebar/dist/theia-sticky-sidebar';

(($) => {
  	const $sidebar = $('#sidebar');
  	$sidebar.theiaStickySidebar({
		additionalMarginTop: 25,
		minWidth: 768,
	});
})(jQuery);
